import styled, { css } from 'styled-components';

export const RadioBlock = styled.div`
  ${({ theme, selected }) => css`
    align-items: start;
    display: inline-block;
    background: ${selected && `linear-gradient(white, white) padding-box, ${theme.v2.colors.gradient.secondary} border-box`};
    border: solid ${selected ? '2px transparent' : '1px'};
    border-color: ${!selected && theme.v2.colors.neutral.highMedium};
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    gap: 12px;
    padding: ${selected ? '16px' : '17px'};
    width: 100%;

    button {
      padding: 0;
    }
  `}
`;

export const RadioBlockContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > :first-child {
    margin-bottom: 4px;
  }

  & > :last-child {
    margin-top: 4px;
  }
`;

export const RadioBlockTitle = styled.h4`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `};
`;

export const RadioBlockDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `};
`;

export const RadioBlockDiscount = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.feedback.activeMedium};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;

    strong {
      font-weight: ${theme.v2.font.weights.bold};
    }
  `};
`;

export const RadioBlockPrice = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxxs};
    margin: 0;

    strong {
      font-weight: ${theme.v2.font.weights.medium};
    }
  `};
`;

export const RadioBlockBottomText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxxs};
    margin: 0;
  `};
`;
